import { BaseView } from "./base-view";
import { Navigation } from "../navigation";
import { Skill } from "../models/Skill";
import { SkillSet } from "../models/SkillSet";
import { Employee } from "../models/Employee";
import { AssignmentDemand } from "../models/AssignmentDemand";
import { buildRouteParamsString, closeModal, createEmployeePhotoElement, createNameIconElementWith2Initials, fireBaseLog, getEmployeeUtilizationByWeek, getWeekNumber, showModal, showToast } from "../common";
import { globalApp } from "../app";
import { PageContext } from "../page-context";
import { DemandStatus } from "../enums/DemandStatus";
import { Project } from "../models/Project";
import { AssignmentsHistory } from "../models/AssignmentsHistory";
import type mdbTypes from '../ext/mdb.min.js';
declare const mdb: typeof mdbTypes
import { CellComponent, ColumnDefinition, Tabulator, RowComponent, TabulatorFull } from "tabulator-tables";
import _ from "lodash";
import { AssignmentComment } from "../models/AssignmentComment";
import { EmployeeUtilization } from "../models/EmployeeUtilization";
import { AssignmentsHistoryEntry } from "../models/AssignmentsHistoryEntry";
import { HistoryFields } from "../enums/HistoryFields";
import { HistoryDateFields } from "../enums/HistoryDateFields";
import { HistoryBooleanFields } from "../enums/HistoryBooleanFields";
import dateTime from "../utils/date-time";
import { Unsubscribe } from "firebase/auth";
import suneditor from 'suneditor';
import { Language } from "../models/Language";
// import 'suneditor/dist/css/suneditor.min.css';



interface EmployeeAutoComplete {
  id: string;
  name: string;
}


export class DemandDetailView extends BaseView {
  planningUpdate = false;
  static title = "Demand Detail";
  static icon = "bi bi-signpost-split";
  dataLoaded: boolean = false;
  secondaryDataQueue: Event[] = [];
  manuallyPlanned: any;
  plannedCurrentData: any;
  suggestedEmployees!: string[];
  skillStructure!: { [key: string]: string[] };
  projectRoles!: string[];
  seniorities!: string[];
  locations!: string[];
  status!: DemandStatus[];
  projects!: Project[];
  employees!: Employee[];
  allEmployeesMap!: Map<string, Employee>;
  customers!: string[];
  employeesUtilization!: EmployeeUtilization[];
  employeesAutoCompleteList!: EmployeeAutoComplete[];
  assignmentHistory!: AssignmentsHistory | null;
  assignmentComments!: AssignmentComment[];
  skillsTable: any;
  languagesTable: any;
  historyDateFields: any;
  dirtyFields: { [key: string]: any } = {};
  data!: AssignmentDemand;
  descriptionEditor: any = null;

  resolve: ((value: unknown | null) => void) | undefined;

  realtimeAssignmentDataUnsubscribe : Promise<Unsubscribe> | null = null;

  /**
   * constructor
   * @param {PageContext} context - The context of the page.
   * @param {string} [container=".main"] - The container to render the view in.
   */
  constructor(context: PageContext, container = ".main") {
    super(context, container);

    globalApp.app.context.activeDemandDetailId = context.data.id;
    this.className = "pageview h-100";

    let versionCheck = this.checkVersionAsync();

    Promise.all([versionCheck]).then(() => {
      this.dataLoaded = false;
      this.secondaryDataQueue = [];

      this.addEventListener("data_loaded", (event) => {
        const target = event.target as unknown as { data: { id: string } };
        if (target && target.data.id === globalApp.app.context.activeDemandDetailId) {
          this.dataLoaded = true;
          this.onDataLoaded();
          this.secondaryDataQueue.forEach((_queueEvent) => this.onSecondaryDataLoaded());
          this.secondaryDataQueue = [];
        }
      });

      this.addEventListener("secondary_data_loaded", (event) => {
        const target = event.target as unknown as { data: { id: string } };
        if (target && target.data.id === globalApp.app.context.activeDemandDetailId) {
          this.dataLoaded ? this.onSecondaryDataLoaded() : this.secondaryDataQueue.push(event);
        }
      });

      this.addEventListener("comments_loaded", () => {
          const commentContainer = document.getElementById('commentContainer');
          if (commentContainer) {
            commentContainer.innerHTML = this.buildCommentItemsHtml();
          }
      });

      if (context.data && context.data.id && !context.data.isNew && context.store.hasBackend) {
        this.realtimeAssignmentDataUnsubscribe = context.store.getAssignmentRealtime(context.data.id, async (data) => {
          if (this.data) {
            this.updateLocalData();
            console.log("changedData", this.dirtyFields);
            Object.keys(data).forEach((key) => {
              let dirtyKey = key as keyof AssignmentDemand;
              if (key == "suggestions") 
                dirtyKey = "suggestedEmployees" as keyof AssignmentDemand;
              
              if (!this.dirtyFields[dirtyKey] && key in this.context.data){
                  this.context.data[key as keyof AssignmentDemand] = data[key as keyof AssignmentDemand];
              }
            });
          }
          this.loadData(context);
        });
      } else {
        this.loadData(context);
      }
    });
  }

  /**
    *Show DemandDetailView as a modal
    * @param {any} context
    * @returns
    */
  static async showAsModal(context: PageContext) {
    $(".modal-dialog").addClass("modal-fullscreen");
    $(".modal-header").hide();

    return await showModal("", DemandDetailView, globalApp.app.context).finally(() => {
      setTimeout(() => {
        $(".modal-dialog").removeClass("modal-fullscreen");
        $(".modal-header").show();
        globalApp.app.context.activeDemandDetailId = null;
      }, 100);
    });
  }


  /**
   * @param {PageContext} context - The context of the page.
   */
  loadData(context: PageContext) {
    if (!context.data) {
      this.data = new AssignmentDemand();
      this.planningUpdate = true;
    } else {
      this.data = context.data;
      this.manuallyPlanned = this.data!.manuallyPlanned;
    }
    this.data.location = (!this.data.location || this.data.location.toLowerCase() === "null") ? "" : this.data.location;
    this.data.customer = (!this.data.customer || this.data.customer.toLowerCase() === "null") ? "" : this.data.customer;

    //variable to store the week calculation for the current choosen dates and planned days
    if (!(this.dirtyFields["startDate"] || this.dirtyFields["endDate"] || this.dirtyFields["pdTotalPlanned"])) {
      this.plannedCurrentData = this.calculateAssignmentPlanning();
    }
    
    document.addEventListener("keydown", async (event) => {
      if (event.key === "Escape") {
        console.log("Escape key pressed");
        await this.unsubscribeRealtimeAssignmentData();
        closeModal();
      }
    }, { once: true });

    this.suggestedEmployees = this.data.suggestions;

    let primaryDataLoad = [
      context.store.getSkillStructure(),
      context.store.getProjectRoles(),
      context.store.getSeniorities(),
      context.store.getLocations(),
      context.store.getStatus(),
      context.store.getProjects(),
      context.store.getAllEmployees(),
      context.store.getAllEmployeesMap(),
      context.store.getCustomers(),
      context.store.getEmployeesUtilization(),
      this.calculateAssignmentPlanning(),
      context.store.getIsoLanguageOptions()
    ];

    let secondaryDataLoad = [
      context.store.getAssignmentHistory(this.data.id),
      context.store.getAssignmentComments(this.data.id)
    ];

    Promise.all(primaryDataLoad).then((values) => {
      this.skillStructure = values[0] as { [key: string]: string[] };
      context.skillStructure = this.skillStructure;
      this.projectRoles = values[1] as string[];
      this.seniorities = values[2] as string[];
      this.locations = values[3] as string[];
      this.status = values[4] as DemandStatus[];
      this.projects = values[5] as Project[];
      this.employees = values[6] as Employee[];
      this.allEmployeesMap = values[7] as Map<string, Employee>;
      this.customers = values[8] as string[];
      if (location.hostname === "localhost" && !this.customers.includes("Test Customer"))
        this.customers.push("Test Customer");
      if (!this.customers.includes("Several Customers")) this.customers.push("Several Customers");
      if (!this.customers.includes("Internal")) this.customers.push("Internal");

      /** @type {Map<string, Array>} */
      this.employeesUtilization = values[9] as EmployeeUtilization[];
      this.plannedCurrentData = values[10];
      context.isoLanguageOptions = values[11] as { label: string; name: string; value: string; }[];

      this.employeesAutoCompleteList = this.employees.map((employee) => {
        return {
          id: employee.id,
          name: employee.employeeName,
        };
      });

      if (this.data.isNew && this.data.projectId !== "" && this.data.customer == "") {
        this.data.customer = this.resolveProjectToCustomer(this.data.projectId);
      }

      setTimeout(() => {
        this.dispatchEvent(new Event("data_loaded"));
      });

      //scroll down comment section on data load
      let observer: IntersectionObserver;
      this.addEventListener("data_loaded", () => {
        const commentContainer = document.getElementById('commentContainer');
        observer?.disconnect();
        observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            if (commentContainer) {
              commentContainer.scrollTop = commentContainer.scrollHeight;
            }
          }
        });
        if (commentContainer instanceof Element) {
          observer.observe(commentContainer);
        }
      });
    });

    Promise.all(secondaryDataLoad).then((values) => {
      const historyData = values[0] as AssignmentsHistory | null;
      if (historyData) {
        this.assignmentHistory = new AssignmentsHistory(historyData.id, historyData.history || []);
      } else {
        this.assignmentHistory = new AssignmentsHistory(this.data.id, []);
      }

      if (this.assignmentHistory.history) {
        this.assignmentHistory.history = this.assignmentHistory.history.map(history => ({
          ...history,
          date: new Date(history.date)
        }));
      }

      this.assignmentComments = (values[1] ?? []) as AssignmentComment[];
      this.dispatchEvent(new Event("comments_loaded"));

      setTimeout(() => {
        this.dispatchEvent(new Event("secondary_data_loaded"));
      });
    });
  }

  resolveProjectToCustomer(projectId: string): string {
    const choosenCustomer = $(this).find("#customer").val();
    if (!this.data.isNew) return choosenCustomer as string;
    if (choosenCustomer === "Test Customer" || choosenCustomer === "Several Customers") return choosenCustomer;
    const project = this.projects.find((project) => project.id === projectId);
    if (!project) return (choosenCustomer === "" || !choosenCustomer) ? "" : choosenCustomer as string;
    const projectName = project ? project.projectName : "";
    const customerName = projectName.split("-")[0].trim();
    //finds the first customer that includes the customerName case sensitive
    const customerNameAvailable =
      customerName == "" ? "" : this.customers.find((customer) => customer.includes(customerName));
    return customerNameAvailable ? customerNameAvailable : "";
  }

  //not sure what to do this
  async getResult(): Promise<unknown> {
    return new Promise((resolve) => {
      this.resolve = resolve;
    });
  }

  connectedCallback(): this {
    super.connectedCallback();
    this.innerHTML = `<span class="placeholder col-7"></span>`;
    return this;
  }

  onDataLoaded() {
    let updateMsg = ``;
    // Concurrency handling by replacing new data with currently edited data
    if (!_.isEmpty(this.dirtyFields)) {
      updateMsg = `<h1 class="fs-7 pe-3 mb-1 text-warning">New data detected. Reload the demand to see new changes</h1>`
      for (let key in this.dirtyFields) {
        if (this.data.plannedWeeks[key] != this.dirtyFields[key]) {
          this.data.plannedWeeks[key] = this.dirtyFields[key];
        }
      }
    }
    this.innerHTML = `
        <div class="demand-detail-view__header">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-xs-12 col-lg-4">
                        <h1 class="modal-title fs-5 pe-3 mb-1">
                            <i class="bi bi-signpost-split"></i> Demand assignment details
                        </h1>
                        ${updateMsg}
                    </div>

                    <div class="col-xs-12 col-sm">
                        <button type="button" class="btn btn-warning btn-delete me-1 mb-1">Delete</button>
                        <button type="button" class="btn btn-secondary btn-duplicate me-1 mb-1">Duplicate</button>
                        <button type="button" class="btn btn-primary btn-savedemand me-1 mb-1" style="background-color: grey;" disabled>Save changes</button>
                        <button type="button" class="btn btn-danger me-1 mb-1" id="closeButton">Close</button>
                    </div>
                </div>
            </div>
            <button type="button" class="btn-close demand-detail-view__btn-close" id="closeModalButton" aria-label="Close"></button>
        </div>

        <div class="container-fluid flex-grow-1">
            <div class="row h-100">
                <form class="col h-100">
                    <div class="row h-100">
                        <div class="col-xl-4 demand-detail-view__divider">
                            <div class="row mb-2">
                                <div class="col">
                                    <label>Created</label> ${this.data.createdDate ? this.data.createdDate.toLocaleDateString() : ""}
                                </div>
                        
                                <div class="col">
                                    <label>Comments</label>
                                    <span class="badge rounded-pill bg-warning comments-info">
                                        ${this.assignmentComments?.length}
                                    </span>
                                </div>
                            </div>

                            <div class="row border-top border-2 py-2 mb-2">
                                <div class="col">
                                    <label for="status">Status</label>
                                    <select class="form-select user-input" id="status">
                                        ${this.buildStatusSelectOptionsHtml()}
                                    </select>
                                    <div class="invalid-feedback status-error"></div>
                                </div>
                                <div class="col">
                                    <label for="dueDate">Due date*</label>
                                    <input type="date" class="form-control user-input date-validation" id="dueDate" value="${this.getHTML5DateValue(
      this.data.dueDate
    )}">
                                    <div class="invalid-feedback dueDate-error"></div>
                                </div>
                            </div>

                            <div class="row border-top border-2 pt-2 mb-2">
                                <div class="col">
                                    <label class="w-100 fw-bold border-bottom border-1">Context</label>
                                </div>
                            </div>

                            <div class="row mb-2">
                                <div class="col">
                                    <label for="projectId">Project*</label>
                                    <input type="text" class="form-control user-input" id="projectId" list="projects" value="${this.data.projectId ?? ""
      }">
                                    <div class="invalid-feedback project-error"></div>
                                </div>

                                <div class="col">
                                    <label for="customer">Customer*</label>
                                    <select class="form-select user-input" id="customer">
                                      <option value="" selected disabled hidden></option>
                                      ${this.buildCustomerSelectOptionsHtml()}
                                    </select>
                                </div>
                            </div>

                            <div class="row mb-2">
                                <div class="col-xs-12 col-sm mb-2 mb-sm-0">
                                    <label for="responsible">Responsible* (<a class="lnk-me" href="#">me</a>)</label>
                                    <input type="text" class="form-control user-input" id="responsible" list="employeeIds" value="${this.data.responsible ?? ""
      }">
                                    <div class="invalid-feedback responsible-error"></div>
                                </div>

                                <div class="col"></div>
                            </div>

                            <div class="row pb-2 mb-2">
                                <div class="col">
                                    <label for="description">Demand description*</label>
                                    <div id="description" style="border: 1px solid #d9d9d9; border-radius: 6px; overflow: hidden;"></div>
                                    <div class="invalid-feedback description-error"></div>
                                </div>
                            </div>

                            <div class="row border-top border-2 pt-2 mb-2">
                                <div class="col">
                                    <label class="w-100 fw-bold border-bottom border-1">Conditions</label>
                                </div>
                            </div>

                            <div class="row mb-2">
                                <div class="col mb-2 mb-sm-0">
                                    <label for="startDate">Start date*</label>
                                    <input type="date" class="form-control user-input date-validation" id="startDate" value="${this.getHTML5DateValue(
        this.data.startDate
      )}">
                                    <div class="invalid-feedback startDate-error"></div>
                                </div>

                                <div class="col">
                                    <label for="endDate">End date*</label>
                                    <input type="date" class="form-control user-input date-validation" id="endDate" value="${this.getHTML5DateValue(
        this.data.endDate
      )}">
                                    <div class="invalid-feedback endDate-error"></div>
                                </div>
                            </div>

                            <div class="row mb-2">
                                <div class="col">
                                    <label for="pdTotalPlanned"  title="Project days (Total)">PD <label class="fw-bold">(Total)</label></label>
                                    <input type="number" class="form-control user-input" id="pdTotalPlanned" value="${this.data.pdTotalPlanned
      }" min="0">
                                </div>

                                <div class="col">
                                    <label for="percentTotalPlanned">%</label>
                                    <input type="text" class="form-control user-input" id="percentTotalPlanned" value="">
                                </div>

                                <div class="col">
                                    <label for="location">Location</label>
                                    <input type="text" class="form-control user-input" id="location" list="locations" value="${this.data.location ?? ""
      }">
                                </div>
                            </div>

                            <div class="row mb-2">
                                <div class="col mb-2 mb-sm-0">
                                    <label for="percentEmployeeUtilisationPlanned" id="percentEmployeeUtilisationPlannedLabel" title="Planned utilisation based on contracted hours">% Utilisation Based</label>
                                    <input type="text" class="form-control user-input" id="percentEmployeeUtilisationPlanned" value="">
                                </div>
                                <div class="col">
                                    <label for="remote">Remote</label>
                                    <select class="form-select user-input" id="remote" value="${this.data.remote}">
                                        <option value="TRUE" ${this.data.remote ? "selected" : ""
      }>True</option>
                                        <option value="FALSE" ${!this.data.remote ? "selected" : ""
      }>False</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-5 demand-detail-view__divider">
                            <div class="row d-none d-lg-flex mb-2">
                                <div class="col">
                                    <div class="invisible">PLACEHOLDER</div>
                                </div>
                            </div>

                            <div class="row border-top border-2 pt-2 mb-2 position-relative">
                                <div class="col mb-1">
                                    <label for="employeeId">Resource ${this.data.employeeId
        ? '<a href="#" class="lnk-findresource">(details)</a>'
        : ''
      }
                                    </label>
                                    <input type="text" class="form-control user-input" id="employeeId" list="employeeIds" value="${this.data.employeeId ?? ""
      }">

                                    <div class="invalid-feedback employeeId-error"></div>
                                </div>
                                <div class="col d-flex align-items-end">
                                    <span role="button" class="btn btn-secondary mb-1 suggestion-info" style="display: block; width: 100%;">
                                        Suggestions (${this.suggestedEmployees.length})
                                    </span>
                                </div>
                            </div>

                            <div class="row mb-2">
                                <div class="col-xs-12 col-sm mb-2 mb-sm-0">
                                    <label for="role">Role*</label>
                                    <input type="text" class="form-control user-input" id="role" list="roles" value="${this.data.role ?? ""
      }">
                                    <div class="invalid-feedback role-error"></div>
                                </div>

                                <div class="col-xs-12 col-sm mb-2 mb-sm-0">
                                    <label for="seniority">Seniority*</label>
                                    <select class="form-select user-input" id="seniority">
                                        <option value="">(Select status)</option>
                                        ${this.buildSenioritySelectOptionsHtml()}
                                    </select>
                                    <div class="invalid-feedback seniority-error"></div>
                                </div>
                            </div>

                            <div class="row mb-2">
                                <div class="col">
                                <div>
                                    <div>
                                        <label class="fw-bold">Skills needed*</label>
                                        <div id="skills-table" style="border-radius: .25rem;"></div>

                                        <button type="button" class="btn btn-sm btn-outline-secondary btn-addSkill mb-1 user-input">
                                            <i class="bi bi-sign-intersection"></i> Add Skill
                                        </button>
                                        <button type="button" class="btn btn-sm btn-outline-secondary btn-magicSkills mb-1 user-input">
                                            <i class="bi bi-magic"></i> From description
                                        </button>
                                        <button type="button" class="btn btn-sm btn-outline-secondary btn-findresource mb-1">
                                            <i class="bi bi-person-check"></i> Find resource
                                        </button>
                                        <button type="button" class="btn btn-sm btn-warning btn-findresourcetooltip mb-1" style="display: none">
                                            <i class="bi bi-info-circle" title="To be able to use the resource finder please save the demand first"></i>
                                        </button>
                                    </div>
                                    <div>
                                      <div id="languages-table" style="border-radius: .25rem; margin-top: 15px;"></div>
                                      <button type="button" class="btn btn-sm btn-outline-secondary btn-addLanguage mb-1 user-input">
                                          <i class="bi bi-sign-intersection"></i> Add Language
                                      </button>
                                    </div>
                                  </div>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col">
                                    <div>
                                        <div class="col">
                                            <div>
                                                <label class="w-100 fw-bold border-bottom border-1">
                                                    History  
                                                    <button type="button" accesskey="r" class="btn btn-xs btn-outline-secondary btn-history-refresh" title="Reload data"><i class="bi bi-arrow-clockwise"></i></button>
                                                    <div class="secondary-data-spinner spinner-border spinner-border-sm history-spinner"></div>
                                                </label>
                                            </div>
                                        </div>
                                        <div style="max-height: 30vh; overflow-y: auto;">
                                            <table class="w-100" id="history-table" style="border-radius: .25rem;"></table>
                                        </div>                                   
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3">
                            <div class="row d-none d-lg-flex mb-2">
                                <div class="col">
                                    <div class="invisible">PLACEHOLDER</div>
                                </div>
                            </div>

                            <div class="row border-top border-2 pt-2 mb-2">
                                <div class="col">
                                    <form>
                                        <label class="w-100 fw-bold border-bottom mb-3">Comment area</label>
                                        <div id="commentContainer" class="max-vh-50 overflow-auto pe-2 mb-2">
                                            ${this.buildCommentItemsHtml()}
                                        </div>

                                        <textarea id="comment" class="form-control lead-input" rows="3" placeholder="Add comment"></textarea>
                                        <button type="button" class="btn btn-sm btn-outline-secondary btn-addComment w-fitcontent lead-input">
                                            <i class="bi bi-chat-left-text"></i> Add comment
                                        </button>
                                    </form>
                                </div>
                            </div>

                            <div class="row d-block d-lg-none" style="height: 30vh;">
                                <div class="d-none">
                                    Do not delete.
                                    This empty space is a workaround for the Skills table editing problems on mobile.
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div>
            <small class="form-text text-muted">*Required fields</small>
        </div>
        

        <datalist id="roles">
        ${this.projectRoles
        .map((role) => {
          return `<option value="${role}">${role}</option>`;
        })
        .join("")}
        </datalist>
        <datalist id="locations">
        ${this.locations
        .map((location) => {
          return `<option value="${location}">${location}</option>`;
        })
        .join("")}
        </datalist>
        <datalist id="projects">
        ${this.projects
        .map((project) => {
          return `<option value="${project.id}">${project.projectName}</option>`;
        })
        .join("")}
        </datalist>

        <datalist id="employeeIds">
            ${this.employeesAutoCompleteList
        .map((employee) => {
          return `<option value="${employee.id}">${employee.name}</option>`;
        })
        .join("")}
        </datalist>
`;

    const elem: JQuery<HTMLElement> = $(this);

    const closeButton = this.querySelector("#closeButton");
    const closeModalButton = this.querySelector("#closeModalButton");

    if (closeButton) {
        closeButton.addEventListener("click", async () => {
          await this.unsubscribeRealtimeAssignmentData();
          closeModal();
        });
    }

    if (closeModalButton) {
        closeModalButton.addEventListener("click", async () => {
          await this.unsubscribeRealtimeAssignmentData();
          closeModal();
        });
    }

    if (elem.find(".placeholder").length > 0) return;

    // Initialize SunEditor
    const convertPlainTextToHtml = (text: string) => {
      if (!text) return '';
      // If content already contains HTML tags, return as is
      if (text.includes('<') && text.includes('>')) {
        return text;
      }
      // Convert plain text line breaks to HTML
      return text.replace(/\n/g, '<br>');
    };

    this.descriptionEditor = suneditor.create('description', {
      height: '200px',
      placeholder: 'Enter demand description...',
      buttonList: [
        ['undo', 'redo'],
        ['font', 'fontSize', 'formatBlock'],
        ['bold', 'underline', 'italic', 'strike'],
        ['fontColor', 'hiliteColor'],
        ['outdent', 'indent'],
        ['align', 'horizontalRule', 'list', 'lineHeight'],
        ['table', 'link'],
        ['fullScreen', 'showBlocks', 'codeView'],
        ['preview', 'print'],
        ['removeFormat']
      ],
      formats: ['p', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
      font: [
        'Logical',
        'Salesforce Sans',
        'Garamond',
        'Sans-Serif',
        'Serif',
        'Times',
        'Helvetica'
      ]
    });

    // Set initial content
    this.descriptionEditor.setContents(convertPlainTextToHtml(this.data.description ?? ''));

    // Listen for changes to mark as dirty
    this.descriptionEditor.onChange = (contents: string) => {
      this.dirtyFields['description'] = contents;
      $(".btn-savedemand").removeAttr('disabled').css("background-color", "");
    };

    // Disable editor if user doesn't have permission
    if (!this.context.user.hasEditPermission() && !this.context.user.isLead()) {
      this.descriptionEditor.readOnly(true);
    }

    if (!this.context.user.isAdmin()) {
      elem.find("#employeeId").attr("disabled", "true");
    }
    if (!this.context.user.hasEditPermission() && !this.context.user.isLead()) {
      $(".lead-input").hide();
      elem.find(".btn-findresource").prop("disabled", true);
    }

    if (this.data.isNew) {
      elem.find(".btn-delete").hide();
      elem.find(".btn-duplicate").hide();
      elem.find(".btn-findresource").prop("disabled", true);
      elem.find(".btn-findresourcetooltip").show();
      elem.find(".btn-savedemand").text("Create Demand");
    }

    if (!_.isEmpty(this.dirtyFields)) {
      $(".btn-savedemand").removeAttr('disabled').css("background-color", "");
    }

    if (this.data.manuallyPlanned) {
      elem.find("#pdTotalPlanned").css("font-style", "italic");
    } else {
      elem.find("#pdTotalPlanned").css("font-style", "normal");
    }

    elem.find("#pdTotalPlanned, #startDate, #endDate").change(async (e) => {
      if (this.manuallyPlanned) {
        if (!confirm("Are you sure you want to change this information? This will replace your weekly planning."))
          $(`#${(e.target as HTMLInputElement).id}`).val((e.target as HTMLInputElement).defaultValue);
        else this.changeManuallyPlanned(false);
      }
      this.utilisationBasedFieldUpdate();
      this.calculateTimeDiffInPercent();
      this.plannedCurrentData = await this.calculateAssignmentPlanning();
    });

    elem.find("#percentTotalPlanned").change(async (e) => {
      const pattern = /^\d+%?$/;

      if (
        !pattern.test((e.target as HTMLInputElement).value) ||
        (this.manuallyPlanned &&
          !confirm("Are you sure you want to change this information? This will replace your weekly planning."))
      )
        return this.calculateTimeDiffInPercent();

      this.changeManuallyPlanned(false);
      this.calculateProjectDaysByPercents();

      this.plannedCurrentData = await this.calculateAssignmentPlanning();
    });

    elem.find("#percentEmployeeUtilisationPlanned").change(async (e) => {
      const pattern = /^\d+%?$/;

      if (
        !pattern.test((e.target as HTMLInputElement).value) ||
        (this.manuallyPlanned &&
          !confirm("Are you sure you want to change this information? This will replace your weekly planning."))
      )
        return this.calculateTimeDiffInPercent();

      this.changeManuallyPlanned(false);
      this.calculateProjectDaysByUtilisationPercents();

      this.plannedCurrentData = await this.calculateAssignmentPlanning();
    });

    elem.find(".btn-history-refresh").click(() => {
      let spinner = document.querySelector(".history-spinner") as HTMLElement | null;
      if (spinner) {
        spinner.style.display = "";
        this.context.store.getAssignmentHistory(this.data.id).then((data) => {
          if (data) {
            this.assignmentHistory = data;
            this.assignmentHistory = this.assignmentHistory
              ? this.assignmentHistory
              : new AssignmentsHistory(this.data.id, []);
            if (this.assignmentHistory.history) {
              this.assignmentHistory.history = this.assignmentHistory.history.map(history => ({
                ...history,
                date: new Date(history.date)
              }));
            }
          }
          this.addHistoryTable();
          spinner.style.display = "none";
        });
      }
    });

    $(".user-input").on("input", (input) => {
      var target = input.currentTarget;
      let id = target.getAttribute("id");
      if (id && id !== 'description') { // Skip description as it's handled by SunEditor
        this.dirtyFields[id] = (target as HTMLInputElement).value;
      }
      $(".btn-savedemand").removeAttr('disabled').css("background-color", "");
    })

    this.calculateTimeDiffInPercent();

    let plannerButtonDisplay = this.context.user.isAdmin() ? "inline-block;" : "none;";
    let pmButtonDisplay = !this.context.user.hasEditPermission()
      ? "none;"
      : "inline-block;";

    let assignButtonHTML = `<button type="button" style="display: ${plannerButtonDisplay} white-space: nowrap; overflow: hidden; text-overflow: ellipsis; grid-area: assign;" class="btn btn-assign btn-primary mr-2 user-input" disabled>Assign</button>`;
    let viewPlanningButtonHTML = `<button type="button" title="Review suggested resources" style="margin-left: 10px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; grid-area: view; display: inline-block;" class="btn btn-view-planning btn-primary mr-2" disabled><i style="font-size: 1.2em;" class="bi bi-calendar2-week"></i></button>`;
    let addButton = `<button style="display: ${pmButtonDisplay}" class="btn btn-secondary btn-sm mx-1 btn-add"><i class="bi bi-plus-lg"></i></button>`;
    let removeButton = `<button style="display: ${pmButtonDisplay}" class="btn btn-secondary btn-sm mx-1 btn-remove"><i class="bi bi-dash-lg"></i></button>`;

    let popoverContent = `
        <div class="suggestions-popover">
            <div style="display: flex; justify-content: flex-end; padding-bottom: 10px;">
              <button type="button" class="btn btn-primary help-toggler" style="margin-right: auto;"><i class="bi bi-question-lg"></i>&nbsp;Help</button>              
              <button type="button" class="btn-close btn-closeSuggestions" aria-label="Close"></button>
            </div>
            <div class="suggestion-help-container">
              <div>Capacity Color:</div>
              <div>- <span style="background-color: green;">&nbsp;&nbsp;</span>Green: Full capacity</div>
              <div>- <span style="background-color: yellow;">&nbsp;&nbsp;</span>Yellow: Limited/No capacity</div>
            </div>
            <form>
              <div id="suggestion-container">
                <div id="suggested-table" class="mb-3"></div>
                <div id="all-employees-table" class="mb-3"></div>
              </div>
              <div style="display: grid; grid-template-columns: 1fr auto; grid-template-areas: 'assign view';">
                  ${assignButtonHTML}
                  ${viewPlanningButtonHTML}
              </div>
            </form>
        </div>`;

    let popoverInstance = new mdb.Popover($(".suggestion-info").show()[0], {
      html: true,
      sanitize: false,
      container: "#detailModal",
      placement: "bottom",
      content: popoverContent,
    });

    $(document).on("click", function (e) {
      if ($(e.target).closest(".popover").length === 0) {
        popoverInstance.hide();
      }
    });

    $(document).ready(() => {
      $(document).off("click", ".help-toggler").on("click", ".help-toggler", () => {
        $(".suggestion-help-container").slideToggle();
      });
    });

    $(document).off("click").on("click", "button.user-input", (e) => {
      $(e.target).trigger("input");
    });



    const createColumn = (title: string, actionButtonHTML: string): ColumnDefinition[] => [
      {
        title: title,
        field: "id",
        frozen: true,
        headerFilter: "input",
        formatter: (cell: CellComponent) => namesWithIconFormatter(cell, actionButtonHTML),
        resizable: false,
        tooltip: true,
      }
    ];

    const handleRowSelectionChanged = function (rows: RowComponent[]) {
      const assignButton = $(".btn-assign");
      assignButton.prop("disabled", !rows[0]);
      let buttonText = `Assign ${rows[0] ? `(${rows[0].getData().id})` : ""}`;
      assignButton.text(buttonText);
      assignButton.attr("title", buttonText);
    };

    const createTable = (selector: string, columns: ColumnDefinition[], data: Employee[]) => {
      const windowHeight = $(window).height();
      let halfWindowHeight = 0;
      if (windowHeight !== undefined)
        halfWindowHeight = windowHeight / 2;
      return new TabulatorFull(selector, {
        height: halfWindowHeight,
        columns: columns,
        selectable: this.context.user.isAdmin() ? 1 : 0,
        layout: "fitColumns",
        initialSort: [{ column: "id", dir: "asc" }],
        data: data
      });

    }
    const actionButtonClick = async (row: RowComponent, sourceTable: Tabulator, targetTable: Tabulator, sourceData: Employee[], targetData: Employee[], suggestedList: Employee[]) => {
      let data = row.getData() as Employee;
      let wasSelected = row.isSelected();
      row.delete();

      sourceData.splice(
        sourceData.findIndex((item) => item.id === data.id),
        1
      );
      targetData.push(data);
      let newRow = await targetTable.addRow(data, true);
      if (wasSelected) targetTable.selectRow(newRow.getData().id);
      targetTable.setSort("id", sourceTable.getSorters()[0].dir);
      this.suggestedEmployees = suggestedList.map((employee) => employee.id);

      this.dirtyFields["suggestedEmployees"] = suggestedList.map((employee) => employee.id);
      $(".btn-savedemand").removeAttr('disabled').css("background-color", "");
      $(".suggestion-info").text(`Suggestions (${this.suggestedEmployees.length})`);
    };

    $(".suggestion-info").on("shown.bs.popover", () => {
      let suggestedEmployeeIds = new Set(this.suggestedEmployees);
      let employees = this.employees.filter((employee) => !suggestedEmployeeIds.has(employee.id));
      let suggestedEmployees = this.employees.filter((employee) => suggestedEmployeeIds.has(employee.id));

      let suggestedEmployeeIdSet = new Set(suggestedEmployees.map((employee) => employee.id));

      suggestedEmployeeIds.forEach((employeeId) => {
        if (!suggestedEmployeeIdSet.has(employeeId)) {
          suggestedEmployees.push(
            new Employee({
              id: employeeId,
              employeeName: employeeId.replace(".", " "),
            })
          );
          suggestedEmployeeIdSet.add(employeeId);
        }
      });

      const suggestedEmployeesTable = createTable(
        "#suggested-table",
        createColumn("Suggested employees", removeButton),
        suggestedEmployees
      );
      const allEmployeesTable = createTable(
        "#all-employees-table",
        createColumn("All employees", addButton),
        employees
      );

      const viewPlanningButton = $(".btn-view-planning");
      viewPlanningButton.prop("disabled", !suggestedEmployees[0]);

      $(document).on("mousedown", ".btn-remove", function (e) {
        let row = suggestedEmployeesTable.getRow($(this).closest(".tabulator-row")[0]);
        $(".btn-savedemand").removeAttr('disabled').css("background-color", "");
        actionButtonClick(
          row,
          suggestedEmployeesTable,
          allEmployeesTable,
          suggestedEmployees,
          employees,
          suggestedEmployees
        );
        viewPlanningButton.prop("disabled", !suggestedEmployees[0]);
      });

      $(document).on("mousedown", ".btn-add", function (e) {
        let row = allEmployeesTable.getRow($(this).closest(".tabulator-row")[0]);
        $(".btn-savedemand").removeAttr('disabled').css("background-color", "");
        actionButtonClick(
          row,
          allEmployeesTable,
          suggestedEmployeesTable,
          employees,
          suggestedEmployees,
          suggestedEmployees
        );
        viewPlanningButton.prop("disabled", !suggestedEmployees[0]);
      });

      suggestedEmployeesTable.on("rowSelectionChanged", function (data, rows, selected) {
        if (data.length != 0) {
          if (allEmployeesTable.getSelectedData().length != 0) {
            allEmployeesTable.deselectRow();
          }
          handleRowSelectionChanged(selected);
        }
      });

      allEmployeesTable.on("rowSelectionChanged", function (data, rows, selected) {
        if (data.length != 0) {
          if (suggestedEmployeesTable.getSelectedData().length != 0) {
            suggestedEmployeesTable.deselectRow();
          }
          handleRowSelectionChanged(selected);
        }
      });


      $(document).on("click", ".btn-closeSuggestions", () => popoverInstance?.hide());

      $(".btn-assign").on("click", async () => {
        $("#employeeId").trigger("input");
        $("#employeeId").val(
          (suggestedEmployeesTable.getSelectedData()[0] || allEmployeesTable.getSelectedData()[0]).id
        );
        $(".btn-savedemand").removeAttr('disabled').css("background-color", "");
        $("#status").val(DemandStatus.Resolved);
      });

      $(".btn-view-planning").on("click", async () => {
        const routeParamsStr = buildRouteParamsString({
          employeeIds: suggestedEmployeesTable.getRows().map((row) => row.getData().id),
        });
        window.open(`#/resource-assignment/?${routeParamsStr}`, "_blank");
      });

      $(".suggestion-info").on("hidden.bs.popover", () => {
        $(document).off("mousedown", ".btn-remove");
        $(document).off("mousedown", ".btn-add");
        $(document).off("click", ".btn-closeSuggestions");
        $(".btn-assign").off("click");
        $(".btn-view-planning").off("click");
      });
    });

    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-mdb-toggle="popover"]'));
    popoverTriggerList.map(function (popoverTriggerEl) {
      return new mdb.Popover(popoverTriggerEl);
    });

    elem.find(".btn-addSkill").click((e) => {
      this.skillsTable.addRow({ level: 1 });
      $(".btn-savedemand").removeAttr('disabled').css("background-color", "");
    });

    elem.find(".btn-addLanguage").click((e) => {
      this.languagesTable.addRow({ level: 1 });
      $(".btn-savedemand").removeAttr('disabled').css("background-color", "");
    });

    elem.find(".btn-magicSkills").click(async (e) => {
      this.showLoading();
      // Get text content from SunEditor, stripping HTML tags
      const input = this.descriptionEditor.getText();
      let {skills, languages} = await this.context.store.getMagicSkills(input);
      skills = skills.filter((skill) => Object.keys(this.skillStructure).includes(skill.category));
      this.skillsTable.setData(skills);
      this.languagesTable.setData(languages);
      this.hideLoading();
    });

    elem.find("#pdTotalPlanned, #startDate, #endDate").change((e) => {
      this.planningUpdate = true;
    });

    elem.find(".lnk-findresource").click((e) => {
      e.preventDefault();
      const employeeId = elem.find("#employeeId").val();
      if (employeeId === "") {
        elem.find("#employeeId").focus();
        return;
      }

      Navigation.navigateHash("/resource-finder/detail", { assignmentId: this.data.id, employeeId: employeeId }, false);

      setTimeout(() => {
        $(".modal-dialog").removeClass("modal-fullscreen");
        $(".modal-header").show();
      });
    });

    elem.find(".lnk-me").click((e) => {
      e.preventDefault();
      elem.find("#responsible").val(this.context.user.userId);
      elem.find("#responsible").trigger("change");
      elem.find("#responsible").trigger("input");
    });



    elem.find(".btn-findresource").click((e) => {
      e.preventDefault();

      const filters = [
        {
          field: "employee.skills",
          value: this.skillsTable
            .getData()
            .filter((skill: Skill) => skill.category != undefined)
            .map((skill: Skill) => skill.category + " - " + skill.skill),
        },
      ];
      let popupUrl = Navigation.buildNavigationUrl("/resource-finder", { assignmentId: this.data.id, filters: filters });
      const newWindow = window.open(popupUrl, "_blank");
      if (newWindow) {
        newWindow.focus();
      }
      //navigateHash("/resource-finder", { assignmentId: this.data.id, filters: filters }, false);
    });

    elem.find(".btn-addComment").click(async (e) => {
      $(".btn-savedemand").removeAttr('disabled').css("background-color", "");
      e.preventDefault();
      e.stopPropagation();

      const commentStr = $("#comment").val();
      if (typeof commentStr !== 'string' || !commentStr.trim()) return;

      if (this.data.isNew) {
        showToast(`${this.data.projectId}: Please save the demand before adding comments.`, "warning");
        return;
      }

      const newSeparateComment = new AssignmentComment({
        message: commentStr,
        createdDate: new Date(),
        createdBy: this.context.user.userId,
        assignmentId: this.data.id,
        projectId: this.data.projectId,
      });

      this.assignmentComments.push(newSeparateComment);
      this.context.store.updateAssignmentComment(newSeparateComment);

      fireBaseLog("assignment_comment_add", { assignmentId: this.data.id });

      showToast(`${this.data.projectId}: Comment added`, "success");

      $("#comment").val("");
      this.dispatchEvent(new Event("comments_loaded"));

      await this.sendEmailToResponsibleEmployeeOnNewComment(commentStr);
      await this.sendEmailToMentionedEmployees(commentStr);
    });

    elem.find("#status").change((e) => {
      if ((e.target as HTMLSelectElement).value === "Resolved") {
        elem.find("#projectId").prop("required", true);
        elem.find("#employeeId").prop("required", true);
      } else {
        elem.find("#projectId").prop("required", false);
        elem.find("#employeeId").prop("required", false);
      }

      this.checkStatusValidity();
    });

    elem.find("#customer").change((e) => this.checkCustomerValidity());
    elem.find("#startDate").change((e) => this.checkStartDateValidity());
    elem.find("#endDate").change((e) => this.checkEndDateValidity());
    elem.find("#dueDate").change((e) => this.checkDueDateValidity());
    elem.find("#seniority").change((e) => this.checkSeniorityValidity());
    // Description change is handled by SunEditor's onChange callback
    elem.find("#employeeId").change((e) => this.handleInputChange("#employeeId"));
    elem.find("#responsible").change((e) => this.handleInputChange("#responsible"));
    elem.find("#projectId").change((e) => this.handleInputChange("#projectId"));
    elem.find("#role").change((e) => this.handleInputChange("#role"));

    elem.find("#status").trigger("change");

    elem.find("#projectId").change((e) => {
      const elem = $(this);
      let customer = elem.find("#customer").val() as string;
      const projectId = elem.find("#projectId").val() as string;

      customer = this.resolveProjectToCustomer(projectId);


      //if selected elemnt is not in the list, add it to the list
      //("Test Customer" is only in the list if it was selected prreviously on the localhost)
      let selectElem = elem.find("#customer");
      if (!selectElem.find(`option[value="${customer}"]`).length) selectElem.append(new Option(customer, customer));

      if (projectId === "") return;
      selectElem.val(customer);
      selectElem.trigger("change");
    });

    elem.find("#employeeId, #responsible, #projectId, #role").change((e) => {
      let response = new Map();
      response.set("employeeId", "employee with id ")
        .set("responsible", "employee with id ")
        .set("projectId", "project with id ")
        .set("role", "role with name ");
      const input = $(e.target);
      const inputType = input.attr('id');
      const inputValue = (input.val() as string).trim();
      const dataList = input.attr("list") as string;
      let validationError = "";

      if (
        inputValue != undefined &&
        dataList && !document.getElementById(dataList)?.querySelector(`option[value="${inputValue}"]`)
      ) {
        validationError = "Cannot find " + response.get(inputType) + inputValue + ". Please choose from the list.";
      }

      this.utilisationBasedFieldUpdate();
      this.calculateTimeDiffInPercent();
      (input[0] as HTMLInputElement).setCustomValidity(validationError);
      input.next().text(validationError);
    });
    this.utilisationBasedFieldUpdate();
    /**
     * Create circles with color based on value and fist letters of names
     * @param {Tabulator.CellComponent} cell
     * @param {object} formatterParams
     * @returns {string}
     */
    const namesWithIconFormatter = (cell: CellComponent, actionButton: string) => {
      var bvid = cell.getValue();
      let row = cell.getRow();
      let data = row.getData() as Employee;

      var name = data.employeeName;
      const iconElement =
        data && data.photo
          ? createEmployeePhotoElement(data.photo, "name-cell-icon")
          : createNameIconElementWith2Initials(name, "name-cell-icon p-1");

      const link = `#/resource-finder/detail?assignmentId=${this.data.id}&employeeId=${bvid}`;

      const div = document.createElement("div");
      div.innerHTML = `
                <div style="position: relative; padding-right: 50px;">
                    <div style="overflow: hidden; display: flex; align-items: center;">
                        <a href='${link}' target='_blank'>
                            <div style="display: inline-block; border-radius: 50%; overflow: hidden; border: 2px solid transparent; outline: 3px solid transparent; outline-offset: -3px;">
                                ${iconElement}
                            </div>
                        </a>
                        <div style="display: flex; align-items: center; padding-left: 10px;">
                            ${bvid}
                        </div>
                    </div>
                    <div style="position: absolute; right: 0; top: 50%; transform: translateY(-50%);">${actionButton}</div>
                </div>`;

      this.getEmployeeCapacityColor(data).then((color) => {
        const outlineDiv = div.querySelector("a > div");
        if (outlineDiv) {
          (outlineDiv as HTMLElement).style.outlineColor = color;
        }
      });

      return div;
    };

    this.setInteractiveStatus(this.context.user.hasEditPermission(), "user-input");
    this.setInteractiveStatus(this.context.user.isLead(), "lead-input");
    this.updateSaveDemandBtnElementByUserRole();
    this.updateDeleteBtnElementByUserRole();

    jQuery(() => {
      const interval = setInterval(() => {
        const tableElement = elem.find("#skills-table");
        if (tableElement.is(":visible")) {
          clearInterval(interval);
          this.addTable(elem); // Initialize the table only when the element is visible
        }
      }, 100); // Check every 100ms
    });

    //languages table
    jQuery(() => {
      const interval = setInterval(() => {
        const tableElement = elem.find("#languages-table");
        if (tableElement.is(":visible")) {
          clearInterval(interval);
          this.addLanguagesTable(); // Initialize the table only when the element is visible
        }
      }, 100); // Check every 100ms
    });
    
    if (this.context.view) {
      this.context.view.hideLoading();
    }
  }

  async unsubscribeRealtimeAssignmentData() {
    if (this.realtimeAssignmentDataUnsubscribe) {
      const unsubscribe = await this.realtimeAssignmentDataUnsubscribe;
      unsubscribe();
      this.realtimeAssignmentDataUnsubscribe = null;
      console.log("Unsubscribing from realtime assignment data");
    }
  }

  //a bit overloaded function, maybe there is a faster way to calculate it in the future
  async getEmployeeCapacityColor(employee: Employee) {
    const utilization = this.employeesUtilization.filter(data => data.id == employee.id);
    const employeePlanning = await this.context.store.getEmployeeAssignmentsByEmployeeId(employee.id); //data from assignments
    if (!employeePlanning) return "#808080";

    const getWeekYearData = (obj: AssignmentDemand | { [s: string]: unknown; } | ArrayLike<unknown>, valueKey: string) =>
      Object.entries(obj)
        .filter(([key, value]) => key.startsWith("cw_") && value != 0)
        .map(([key, value]) => ({ cw: key.split("_")[1], year: key.split("_")[2], [valueKey]: value }));

    const employeePlanningCW = getWeekYearData(employeePlanning.plannedWeeks, "capacity");
    const currentProjectPlanningCW = getWeekYearData(this.plannedCurrentData.plannedWeeks, "plannedHrs");
    let employeeEndDate = employee.employmentPeriods[employee.employmentPeriods.length - 1].endDate ? employee.employmentPeriods[employee.employmentPeriods.length - 1].endDate : undefined;

    if (this.plannedCurrentData.endDate && employeeEndDate && this.plannedCurrentData.endDate > employeeEndDate) 
      return "#FFFF00";

    if (currentProjectPlanningCW.length == 0) return "#008000";

    const employeePlanningMap = new Map(employeePlanningCW.map((item) => [`${item.cw}_${item.year}`, item.capacity]));

    for (let currentProjectWeek of currentProjectPlanningCW) {
      let employeeWeekCapacity = employeePlanningMap.get(`${currentProjectWeek.cw}_${currentProjectWeek.year}`);
      employeeWeekCapacity = employeeWeekCapacity ? employeeWeekCapacity : 0;
      const employeeCapacity = utilization[0] ? getEmployeeUtilizationByWeek(utilization[0].utilization, Number(currentProjectWeek.cw), Number(currentProjectWeek.year)) : 40;

      if (currentProjectWeek.plannedHrs + employeeWeekCapacity > employeeCapacity) return "#FFFF00";
    }

    return "#008000";
  }

  onSecondaryDataLoaded() {
    this.addHistoryTable();

    document.querySelectorAll(".secondary-data-spinner").forEach((el) => ((el as HTMLElement).style.display = "none"));
  }

  changeManuallyPlanned(manuallyPlanned: boolean) {
    this.manuallyPlanned = manuallyPlanned;
    this.planningUpdate = true;
  }

  checkSkillsValidity() {
    let result: boolean = true;
    const [form] = $(this).find("form");
    if (!form.classList.contains("was-validated")) return false;

    const skillsTable = document.getElementById("skills-table");
    const fullskills: Skill[] = this.skillsTable.getData().filter(({ category, skill, level }: { category: string; skill: string; level: number }) => category && skill && level);
    if (fullskills.length != 0) {
      const skills: Skill[] = this.skillsTable.getData();
      skills.some((skill: Skill) => {
        if (this.skillStructure[skill.category] && !this.skillStructure[skill.category].includes(skill.skill)) {
          result = false;
        }
      })
      result = result || false;
    } else {
      result = false;
    }
    if (skillsTable) {
      skillsTable.style.border = result ? "1px solid rgb(76, 175, 80)" : "1px solid red";
    }
    return result;
  }

  checkStatusValidity() {
    let elem = $(this);
    let validationError = "";
    let status = elem.find("#status");

    if (
      !this.context.user.isAdmin() &&
      $("#employeeId").attr("disabled") === "disabled" &&
      $("#employeeId").prop("required") &&
      !elem.find("#employeeId").val()
    ) {
      validationError = "Cannot set status to Resolved without assigning a resource.";
      (status[0] as HTMLInputElement).setCustomValidity(validationError);
      status.next().text(validationError);
      return false;
    } else {
      status.next().text(validationError);
      (status[0] as HTMLInputElement).setCustomValidity(validationError);
      return true;
    }
  }

  checkStartDateValidity() {
    const elem = $(this);
    const startDateValue = elem.find("#startDate").val() as string | number;
    const startDate = new Date(startDateValue);
    const dueDateValue = elem.find("#dueDate").val() as string | number;;
    const dueDate = new Date(dueDateValue);
    dueDate.setHours(0, 0, 0, 0);
    startDate.setHours(0, 0, 0, 0);

    if (isNaN(startDate.getTime()) || isNaN(dueDate.getTime()) || !dueDateValue || !startDateValue) {
      (elem.find("#startDate")[0] as HTMLInputElement).setCustomValidity("Please enter a valid date.");
      $(".startDate-error").text("Please enter a valid date.");
      return false;
    } else {
      if (startDate >= dueDate) {
        (elem.find("#startDate")[0] as HTMLInputElement).setCustomValidity("");
        $(".startDate-error").text("");
        $(".invalid-feedback.startDate-error").removeClass("invalid-feedback-show");
        $("#startDate").removeClass("invalid-border-show");
        return true;
      } else {
        const error = "Start date before due date.";
        (elem.find("#startDate")[0] as HTMLInputElement).setCustomValidity(error);
        $(".startDate-error").text(error);
        $(".invalid-feedback.startDate-error").addClass("invalid-feedback-show");
        $("#startDate").addClass("invalid-border-show");
        return false;
      }
    }
  }

  checkEndDateValidity() {
    const elem = $(this);

    const startDateValue = elem.find("#startDate").val() as string | number;
    const startDate = new Date(startDateValue);
    const endDateValue = elem.find("#endDate").val() as string | number;;
    const endDate = new Date(endDateValue);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime()) || !endDateValue || !startDateValue) {
      (elem.find("#endDate")[0] as HTMLInputElement).setCustomValidity("Please enter a valid date.");
      $(".endDate-error").text("Please enter a valid date.");
      return false;
    } else {
      if (endDate >= startDate) {
        (elem.find("#endDate")[0] as HTMLInputElement).setCustomValidity("");
        $(".endDate-error").text("");
        $(".invalid-feedback.endDate-error").removeClass("invalid-feedback-show");
        $("#endDate").removeClass("invalid-border-show");
        return true;
      } else {
        const error = "End date smaller than Start date.";
        (elem.find("#endDate")[0] as HTMLInputElement).setCustomValidity(error);
        $(".endDate-error").text(error);
        $(".invalid-feedback.endDate-error").addClass("invalid-feedback-show");
        $("#endDate").addClass("invalid-border-show");
        return false;
      }
    }
  }

  handleInputChange(id: string) {
    const input = $(id);
    const inputValue = (input.val() as String).trim();
    const dataList = input.attr("list") as string;
    let validationError = "";

    if (
      inputValue != undefined &&
      !document.getElementById(dataList)?.querySelector(`option[value="${inputValue}"]`)
    ) {
      validationError = "Invalid input. Please choose from the list.";
    }

    this.utilisationBasedFieldUpdate();
    this.calculateTimeDiffInPercent();
    (input[0] as HTMLInputElement).setCustomValidity(validationError);
    input.next().text(validationError);

    return validationError === "" ? true : false;
  }

  checkSeniorityValidity() {
    const elem = $(this);
    const value = elem.find("#seniority").val();
    if (!value || value === "") {
      (elem.find("#seniority")[0] as HTMLInputElement).setCustomValidity("Please select a seniority level.");
      $(".seniority-error").text("Please select a seniority level.");
      return false;
    }
    else {
      (elem.find("#seniority")[0] as HTMLInputElement).setCustomValidity("");
      $(".seniority-error").text("");
      return true;
    }
  }

  checkDescriptionValidity() {
    // Get text content from SunEditor (strips HTML tags)
    const value = this.descriptionEditor ? this.descriptionEditor.getText().trim() : '';
    if (!value || value === "") {
      $(".description-error").text("Please enter a description.");
      return false;
    }
    else {
      $(".description-error").text("");
      return true;
    }
  }

  checkDueDateValidity() {
    const elem = $(this);
    const dueDate = new Date(elem.find("#dueDate").val() as string);
    const createdDate = this.data.createdDate;
    dueDate.setHours(0, 0, 0, 0);
    createdDate.setHours(0, 0, 0, 0);

    if (isNaN(dueDate.getTime()) || !dueDate) {
      (elem.find("#dueDate")[0] as HTMLInputElement).setCustomValidity("Please enter a valid date.");
      $(".dueDate-error").text("Invalid date format. Please enter a valid date.");
      return false;
    } else {
      if (dueDate >= createdDate) {
        (elem.find("#dueDate")[0] as HTMLInputElement).setCustomValidity("");
        $(".dueDate-error").text("");
        $(".invalid-feedback.dueDate-error").removeClass("invalid-feedback-show");
        $("#dueDate").removeClass("invalid-border-show");
        return true;
      } else {
        const error = "Due date already passed.";
        (elem.find("#dueDate")[0] as HTMLInputElement).setCustomValidity(error);
        $(".dueDate-error").text(error);
        $(".invalid-feedback.dueDate-error").addClass("invalid-feedback-show");
        $("#dueDate").addClass("invalid-border-show");
        return false;
      }
    }
  }

  checkCustomerValidity() {
    let elem = $(this);
    let validationError = "";
    if (!elem.find("#customer").val()) {
      let customer = elem.find("#customer");
      validationError = "Input invalid. Please choose from the list.";
      (customer[0] as HTMLInputElement).setCustomValidity(validationError);
      customer.next().text(validationError);
      return false;
    }
    else {
      let customer = elem.find("#customer");
      customer.next().text(validationError);
      (customer[0] as HTMLInputElement).setCustomValidity(validationError);
      return true;
    }
  }

  addHistoryTable() {
    const historyShownFields = {
      "Status": "Changed <Label>Status</Label> to",
      "Suggestions": "<Label>Suggested</Label>",
      "Resource": "<Label>Assigned</Label>",
      "Skills needed": "Changed <Label>Needed Skills</Label> to",
      "Languages": "Changed <Label>Languages</Label> to",
      "Start date": "Changed <Label>Start date</Label> to",
      "End date": "Changed <Label>End date</Label> to",
      "Due date": "Changed <Label>Due date</Label> to",
      "Responsible": "Changed <Label>Responsible</Label> to",
      "Role": "Changed <Label>Role</Label> to",
      "Seniority": "Changed <Label>Seniority</Label> to",
      "Demand Created":
        'Created Demand <div onclick="toggleCreationTableVisibility()" style="cursor: pointer; display: inline;">...</div>',
      "Demand Copied": "Copied from",
      "Project Id": "Changed <Label>Project</Label> to",
      "Customer": "Changed <Label>Customer</Label> to",
      "Demand description": "Changed <Label>Description</Label> to",
      "Location": "Changed <Label>Location</Label> to",
      "Remote": "Changed <Label>Remote</Label> to",
      "PD Total Planned": "Changed <Label>PD (Total)</Label> to",
    };

    (window as any).toggleCreationTableVisibility = function () {
      const table = document.getElementById('creationDetailTable');
      if (table) {
        table.style.display = table.style.display === 'none' ? 'block' : 'none';
      }
    };

    const historyTable = document.getElementById("history-table");
    let tableContent = "";
    let assignmentHistoryCopy = this.assignmentHistory 
        ? JSON.parse(JSON.stringify(this.assignmentHistory.history), (key, value) => {
            if (key === 'date') {
                return new Date(value);
            }
            return value;
        }) as AssignmentsHistoryEntry[] 
        : undefined;    
      if (assignmentHistoryCopy && assignmentHistoryCopy.length > 0) {
      tableContent = assignmentHistoryCopy
        .sort((a, b) => b.date.getTime() - a.date.getTime())
        .filter((history) =>
          Object.keys(history.changes).some((key) =>
            Object.keys(historyShownFields).includes(key)))
        .map((history) => {
          return `<tr class="border-bottom border-1">
                        <td style="vertical-align: top; white-space: nowrap;">${new Date(
            history.date
          ).getFullYear()}-${("0" + (new Date(history.date).getMonth() + 1)).slice(-2)}-${(
            "0" + new Date(history.date).getDate()
          ).slice(-2)} - ${("0" + new Date(history.date).getHours()).slice(-2)}:${(
            "0" + new Date(history.date).getMinutes()
          ).slice(-2)} <span style="display: inline-block;">${history.user
            .replace(/\b\w/g, (l) => l.toUpperCase())
            .replace(".", " ")}:</span></td>                        
                        <td style="vertical-align: top; width: 100%;">
                            <table style="width: 100%;">
                                ${Object.entries(history.changes)
              .map(([key, value], index, array) => {
                if (Object.keys(historyShownFields).includes(key)) {
                  let borderClass = index !== array.length - 1 ? "border-bottom border-1" : "";
                  if (key == "Skills needed") {
                    const subarrays = Object.values((value as any).new.skills);
                    const flattenedArray = subarrays.reduce((acc: any, val) => acc.concat(val), []);
                    value.new = new SkillSet(flattenedArray as any);
                  }
                  else if (key == "Languages") {
                    const subarrays = Object.values((value as any).new);
                    const flattenedArray = subarrays.reduce((acc: any, val) => acc.concat(val), []);
                    value.new = (flattenedArray as Language[]).map(language => `${language.isNative ? "Native" : ""} ${language.certified ? "Certified" : ""} ${language.language} ${Language.getLevelStringFromNumber(language.level)}`).join(" | ");
                  }
                  else if (key == "Demand Created")
                    value.new = `<table style="width: 100%; font-size: 0.8em; display: none;" id="creationDetailTable">
                          ${Object.keys(value).map((key) => {
                      if (key === "Skills needed") {
                        const subarrays = Object.values((value as any)[key].new.skills);
                        const flattenedArray = subarrays.reduce((acc: any, val) => acc.concat(val), []);
                        return `<tr class="border-bottom border-1"><td>${key}:</td><td>${new SkillSet(flattenedArray as any)}</td></tr>`;
                      } else {
                        return `<tr class="border-bottom border-1"><td>${key}:</td><td>${(value as any)[key].new}</td></tr>`;
                      }
                    })
                        .join("")}
                                        </table>`;
                  if (key == "Demand Copied") {
                    return `Copied from <Label>${value.old}</Label> to <Label>${value.new}</Label>`;;
                  }
                  return `<tr class="${borderClass}">
                            <td>${historyShownFields[key as keyof typeof historyShownFields]} <Label>${Array.isArray(value.new) ? value.new.join(", ") : value.new ? value.new : ""
                    }</Label></td>
                                        </tr>`;
                }
                return "";
              })
              .join("")
            }
    </table>
      </td >
      </tr>`;
        })
        .join("");
    }
    if (historyTable) {
      historyTable.innerHTML = tableContent;
    }
  }

  addLanguagesTable(elem: JQuery<HTMLElement> = $(this)) { 
    let languages = this.data.languages;

    const columns: ColumnDefinition[] = [
      {
        title: "Language",
        field: "language",
        editor: this.context.user.hasEditPermission() ? "list" : undefined,
        widthGrow: 10,
        editorParams: (cell: CellComponent) => {
            const usedLanguages = languages.map(l => l.language);
            const currentLanguage = cell.getValue();
            const options = this.context.isoLanguageOptions
                .filter(lang => !usedLanguages.includes(lang.name) || lang.name === currentLanguage)
                .map(lang => lang.name);
            return { values: options };
        },
      },
      {
        title: "Level",
        field: "level",
        editor: this.context.user.hasEditPermission() ? "list" : undefined,
        widthGrow: 5,
        formatter: (cell: CellComponent) => Language.getLevelStringFromNumber(cell.getValue()),
        editorParams: {
            values: [
                { label: "A1", value: 1 },
                { label: "A2", value: 2 },
                { label: "B1", value: 3 },
                { label: "B2", value: 4 },
                { label: "C1", value: 5 },
                { label: "C2", value: 6 }
            ]
        }
      },
      {
        title: "Native",
        field: "isNative",
        formatter: (cell: CellComponent) => cell.getValue() ? "Yes" : "No",
        widthGrow: 5,
        editor: this.context.user.hasEditPermission() ? "list" : undefined,
        editorParams: {
            values: [
                { label: "Yes", value: true },
                { label: "No", value: false }
            ]
        }
      },
      {
        title: "Certified",
        field: "certified",
        formatter: (cell: CellComponent) => cell.getValue() ? "Yes" : "No",
        widthGrow: 5,
        editor: this.context.user.hasEditPermission() ? "list" : undefined,
        editorParams: {
            values: [
                { label: "Yes", value: true },
                { label: "No", value: false }
            ]
        }
      },
      {
        formatter: (cell: CellComponent) => '<i class="bi bi-file-x"></i>',
        width: 10,
        widthGrow: 1,
        headerSort: false,
        visible: this.context.user.hasEditPermission(),
        cellClick: (e: UIEvent, cell: CellComponent) => {
          cell.getRow().delete();
          $(".btn-savedemand").removeAttr('disabled').css("background-color", "");
        },
        title: ""
      },
    ];

    const table = new TabulatorFull(elem.find("#languages-table")[0], {
      layout: "fitColumns",
      columns: columns,
    });

    const languagesCopy = JSON.parse(JSON.stringify(languages));
    table.on("tableBuilt", () => {
      table.setData(languagesCopy);
    });

    table.on("dataChanged", (data) => {
      $(".btn-savedemand").removeAttr('disabled').css("background-color", "");
      this.dirtyFields["languages"] = data;
    });

    this.languagesTable = table;

    return this;
  }

  addTable(elem: JQuery<HTMLElement>) {
    let skills = this.data.skills.skills;

    if (skills.length === 0) {
      skills.push({ level: 1, category: "", skill: "", name: "" });
    }

    const columns: ColumnDefinition[] = [
      {
        title: "Category",
        field: "category",
        editor: this.context.user.hasEditPermission() ? "list" : undefined,
        widthGrow: 10,
        editorParams: { values: Object.keys(this.skillStructure) },
        cellEdited: function (cell: CellComponent) {
          cell.getRow().getCells().forEach(rowCell => { if (rowCell != cell) rowCell.setValue(undefined); })
        }
      },
      {
        title: "Skill",
        field: "skill",
        editor: this.context.user.hasEditPermission() ? "list" : undefined,
        widthGrow: 10,
        editorParams: function (cell: CellComponent) {
          const category = cell.getRow().getData().category;
          if (!category || !globalApp.app.context.skillStructure[category]) return [];
          return { values: globalApp.app.context.skillStructure[category] };
        },
      },
      {
        title: "Level",
        field: "level",
        formatter: "star",
        widthGrow: 5,
        width: 100,
        formatterParams: { stars: 4 },
        editor: this.context.user.hasEditPermission() ? "list" : undefined,
        editorParams: { values: [1, 2, 3, 4] },
      },
      {
        formatter: (cell: CellComponent) => '<i class="bi bi-file-x"></i>',
        width: 10,
        widthGrow: 1,
        headerSort: false,
        visible: this.context.user.hasEditPermission(),
        cellClick: (e: UIEvent, cell: CellComponent) => {
          cell.getRow().delete();
          $(".btn-savedemand").removeAttr('disabled').css("background-color", "");
        },
        title: ""
      },
    ];

    var skillscopy = JSON.parse(JSON.stringify(skills));
    const table = new TabulatorFull(elem.find("#skills-table")[0], {
      layout: "fitColumns",
      columns: columns,
    });

    table.on("tableBuilt", () => {
      table.setData(skillscopy);
    });

    table.on("dataChanged", (data) => {
      $(".btn-savedemand").removeAttr('disabled').css("background-color", "");
      this.dirtyFields["skills"] = data;
      this.checkSkillsValidity();
    });

    this.skillsTable = table;

    const blurEvent = () => { };
    window.removeEventListener("resize", blurEvent);

    return this;
  }

  calculateWorkingDays() {
    const elem = $(this);
    const startDate = new Date(elem.find("#startDate").val() as string);
    const endDate = new Date(elem.find("#endDate").val() as string);

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return;

    const workingDays = [];
    let currentDate = startDate;
    while (currentDate <= endDate) {
      if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
        workingDays.push(currentDate);
      }
      currentDate = new Date(currentDate.getTime() + 24 * 60 * 60 * 1000);
    }
    return workingDays.length;
  }

  calculateMedianUtalisation() {
    const elem = $(this);
    const startDate = new Date(elem.find("#startDate").val() as string);
    const endDate = new Date(elem.find("#endDate").val() as string);
    const employeeUtalization = this.employeesUtilization.filter(data => data.id == elem.find("#employeeId").val());

    if (employeeUtalization.length > 0 && (isNaN(getWeekNumber(endDate)) || isNaN(endDate.getFullYear()))) {
      const currentDate = new Date();
      const currentWeek = getWeekNumber(currentDate);
      const currentYear = currentDate.getFullYear();
      return getEmployeeUtilizationByWeek(employeeUtalization[0].utilization, Number(currentWeek), Number(currentYear));
    }

    let totalHours = 0, weekCount = 0;
    for (let date = startDate; date <= endDate; date.setDate(date.getDate() + 7)) {
      const week = getWeekNumber(date);
      const year = date.getFullYear();
      totalHours += employeeUtalization.length > 0 ? getEmployeeUtilizationByWeek(employeeUtalization[0].utilization, week, year) : 40;
      weekCount++;
    }
    return parseFloat((totalHours / weekCount).toFixed(1));
  }

  async calculateAssignmentPlanning() {
    const elem = $(this);

    let data = JSON.parse(JSON.stringify(this.data));

    if (this.manuallyPlanned) return data;

    Object.keys(data).forEach((key) => {
      if (key.startsWith("cw_")) delete data[key];
    });

    let startDateElement = elem.find("#startDate");
    let endDateElement = elem.find("#endDate");
    let totalPlannedElement = elem.find("#pdTotalPlanned");

    data.pdTotalPlanned = totalPlannedElement.length > 0 ? elem.find("#pdTotalPlanned").val() : data.pdTotalPlanned;
    const startDateValue = elem.find("#startDate").val();
    data.startDate = startDateElement.length > 0 ? new Date(startDateValue as string) : new Date(data.startDate);
    data.endDate = endDateElement.length > 0 ? new Date(elem.find("#endDate").val() as string) : new Date(data.endDate);

    return await this.context.store.calculateAssignmentWeeklyHours(
      data,
      dateTime.getTimeWindowFrom(data.startDate, 2),
      dateTime.getTimeWindowTo(data.endDate, 2)
    );
  }

  utilisationBasedFieldUpdate() {
    const elem = $(this);
    const utilisationField = elem.find("#percentEmployeeUtilisationPlanned");
    const utilizationLabel = elem.find("#percentEmployeeUtilisationPlannedLabel");
    const employeeIdValueRaw = elem.find("#employeeId").val();
    const employeeIdValue = typeof employeeIdValueRaw === 'string' ? employeeIdValueRaw.trim() : '';
    const medianUtalisation = this.calculateMedianUtalisation();

    if (!employeeIdValue || !this.allEmployeesMap.has(employeeIdValue)) {
      utilisationField.val("").prop("disabled", true);
      utilizationLabel.text("Utilisation %");
    } else {
      utilisationField.prop("disabled", false);
      utilizationLabel.text(`Utilisation % ≈ ${medianUtalisation} hrs per week`);
    }
  }

  calculateTimeDiffInPercent(days = this.calculateWorkingDays()) {
    const elem = $(this);
    const totalPlanned = parseInt(elem.find("#pdTotalPlanned").val() as string) || 0;
    const medianWeekUtalisation = this.calculateMedianUtalisation();
    const percentEmployeeUtilisationPlanned = elem.find("#percentEmployeeUtilisationPlanned");

    if (!days || days < 0) return;

    elem.find("#pdTotalPlanned").val(totalPlanned).css("font-style", "normal");
    elem.find("#percentTotalPlanned").val(Math.round((totalPlanned / days) * 100) + "%");

    percentEmployeeUtilisationPlanned.val(
      percentEmployeeUtilisationPlanned.prop('disabled') ? "" : Math.round((totalPlanned / days) * (100 / medianWeekUtalisation * 40)) + "%"
    );
  }

  calculateProjectDaysByPercents(days = this.calculateWorkingDays()) {
    const elem = $(this);
    let percentPlanned = parseInt(elem.find("#percentTotalPlanned").val() as string || '0');
    if (!days || days < 0) return;
    elem.find("#pdTotalPlanned").val(Math.round((days * percentPlanned) / 100));
    this.calculateTimeDiffInPercent(days);
  }

  calculateProjectDaysByUtilisationPercents(days = this.calculateWorkingDays()) {
    const elem = $(this);
    let percentPlanned = parseInt(elem.find("#percentEmployeeUtilisationPlanned").val() as string || '0');
    let medianWeekUtalisation = this.calculateMedianUtalisation();
    if (!days || days < 0) return;
    elem.find("#pdTotalPlanned").val(Math.round((days * percentPlanned) / (100 / medianWeekUtalisation * 40)));
    this.calculateTimeDiffInPercent(days);
  }

  async writeHistory(changedData: AssignmentsHistoryEntry): Promise<AssignmentsHistoryEntry | undefined> {
    let newHistoryElement: AssignmentsHistoryEntry = new AssignmentsHistoryEntry(this.context.user.userId, new Date(), changedData.changes);
    if (changedData && Object.keys(changedData).length > 0 && !this.data.isNew)
      newHistoryElement = new AssignmentsHistoryEntry(this.context.user.userId, new Date(), changedData.changes);
    else if (this.data.isNew) {

      newHistoryElement = new AssignmentsHistoryEntry(this.context.user.userId, new Date(), { "Demand Created": changedData.changes});
    }
    if (newHistoryElement.changes) {
      return newHistoryElement;
    }
    return undefined;
  }

  async updateHistory() {
    const changedData = await this.findChangedData(false);
    let newHistoryElement = await this.writeHistory(changedData);
    if (newHistoryElement == undefined) return;

    if (!this.assignmentHistory)
      this.assignmentHistory = new AssignmentsHistory(this.data.id, []);

    this.assignmentHistory.history = this.assignmentHistory.history || [];

    this.assignmentHistory.history.push(newHistoryElement);


    if (Object.keys(changedData).length > 0) {
      this.context.store.updateAssignmentHistory({
        id: this.data.id,
        history: this.assignmentHistory.history,
      });
    }
  }

  async updateLocalData() {
    let elem = $(this);

    this.data.isNew = false;
    this.data.customer = elem.find("#customer").val() ? String(elem.find("#customer").val()) : "";
    // Get HTML content from SunEditor
    this.data.description = this.descriptionEditor ? this.descriptionEditor.getContents() : "";
    this.data.startDate = elem.find("#startDate").val() ? new Date(elem.find("#startDate").val() as string) : new Date();
    this.data.endDate = elem.find("#endDate").val() ? new Date(elem.find("#endDate").val() as string) : new Date();
    this.data.role = elem.find("#role").val() ? elem.find("#role").val() as string : "";
    this.data.seniority = elem.find("#seniority").val() ? elem.find("#seniority").val() as string : "";
    this.data.pdTotalPlanned = elem.find("#pdTotalPlanned").val() ? Number(elem.find("#pdTotalPlanned").val()) : 0;
    this.data.location = elem.find("#location").val() ? elem.find("#location").val() as string : "";
    this.data.remote = elem.find("#remote").val() ? Boolean(elem.find("#remote").val()) : false;
    this.data.status = elem.find("#status").val() ? elem.find("#status").val() as string : "";
    this.data.projectId = elem.find("#projectId").val() ? elem.find("#projectId").val() as string : "";
    this.data.employeeId = elem.find("#employeeId").val() ? elem.find("#employeeId").val() as string : "";
    this.data.responsible = elem.find("#responsible").val() ? elem.find("#responsible").val() as string : "";
    this.data.dueDate = elem.find("#dueDate").val() ? new Date(elem.find("#dueDate").val() as string) : new Date();
    this.data.manuallyPlanned = this.manuallyPlanned;
    this.data.suggestions = this.suggestedEmployees;
    this.data.languages = this.languagesTable.getData();

    var skills = this.skillsTable.getData();
    this.data.skills = new SkillSet();
    skills.forEach((skill: Skill) => {
      if (!skill.skill || !skill.category) return;
      this.data.skills.addSkill(new Skill(skill.category, skill.skill, skill.level));
    });

    if (this.planningUpdate) {
      this.data = await this.context.store.calculateAssignmentWeeklyHours(
        this.data
      );
    }

    return this.data;
  }

  async validateForm() {
    let elem = $(this);
    let form = elem.find("form")[0];
    //let formValidity = form.checkValidity();
    form.classList.add("was-validated");

    let changes = await this.findChangedData();

    let isNew = this.data.isNew;
    let result = true;
    if (isNew || changes.changes[HistoryFields.customer]) result = this.checkCustomerValidity() && result;
    if (isNew || changes.changes[HistoryFields.description]) result = this.checkDescriptionValidity() && result;
    if (isNew || changes.changes[HistoryFields.role]) result = this.handleInputChange("#role") && result;
    if (isNew || changes.changes[HistoryFields.seniority]) result = this.checkSeniorityValidity() && result;
    if (isNew || changes.changes[HistoryFields.status]) result = this.checkStatusValidity() && result;
    if (isNew || changes.changes[HistoryFields.projectId]) result = this.handleInputChange("#projectId") && result;
    if (isNew || changes.changes[HistoryFields.responsible]) result = this.handleInputChange("#responsible") && result;
    if (isNew || changes.changes[HistoryDateFields.startDate]) result = this.checkStartDateValidity() && result;
    if (isNew || changes.changes[HistoryDateFields.endDate]) result = this.checkEndDateValidity() && result;
    if (isNew || changes.changes[HistoryDateFields.dueDate]) result = this.checkDueDateValidity() && result;
    if (isNew || changes.changes["Skills needed"]) result = this.checkSkillsValidity() && result;

    elem.find("#employeeId, #responsible, #projectId, #role").each(function () {
      var $this = $(this);
      const value = $this.val();
      if (typeof value === 'string') {
        $this.val(value.trim());
      }
    });

    return result;
  }

  setInteractiveStatus(isInteractive: boolean, className: string) {
    if (!isInteractive) {
      Array.from(document.getElementsByClassName(className)).forEach((element) => {
        if (element.tagName === "BUTTON") {
          element.classList.add("disabled");
        } else if (element.tagName === "SELECT" || (element as HTMLInputElement).type === "date") {
          element.classList.add("non-interactive");
        } else {
          element.setAttribute("readonly", 'true');
        }
      });
    }
  }

  updateSaveDemandBtnElementByUserRole() {
    const elem = $(this);
    const closedStatus = "Resolved, Dropped, Lost";
    const savedemandHtml = `
        <div class="container-fluid">
          <div class="row">
            <div class="col">
              <h4>Please add a comment before closing demand</h4>
              <textarea class="form-control" rows="5" id="demand-close-comment">[Closed]</textarea>
              <br>
              <button class="btn btn-primary add-comment-savedemand">Add message and save</button>
            </div>
          </div>
        </div>`;

    if (!this.context.user.hasEditPermission()) {
      elem.find(".btn-savedemand").hide();
      elem.find(".btn-duplicate").hide();
      return;
    }

    elem.find(".btn-duplicate").click(async (e) => {
      let copyData = { ...this.data };
      copyData.id = "";
      copyData.createdDate = new Date();
      copyData.comments = [];
      copyData.employeeId = "";
      copyData.status = DemandStatus.Open;

      let ctx = Object.assign(this.context, { data: AssignmentDemand.createNew(copyData) });
      Navigation.restorePreviousHashUrl();
      if (this.resolve) {
        await this.unsubscribeRealtimeAssignmentData();
        this.resolve(await DemandDetailView.showAsModal(ctx));
      }
    });

    const sdPopoverInstance = new mdb.Popover($(".btn-savedemand").show()[0], {
      html: true,
      sanitize: false,
      container: "#detailModal",
      placement: "bottom",
      content: savedemandHtml,
      trigger: "manual"
    });

    $(document).on("click", function(e) {
      if ($(e.target).closest(".popover").length === 0 && !$(e.target).hasClass("btn-savedemand")) {
        sdPopoverInstance.hide();
      }
    });

    $(document).on("click", (e) => {
      if ($(e.target).hasClass("add-comment-savedemand")) {
        e.preventDefault();
        e.stopPropagation();
        this.data.comments.push(new AssignmentComment({
          message: (document.getElementById("demand-close-comment") as HTMLInputElement).value,
          createdDate: new Date(),
          createdBy: this.context.user.userId,
        }));
        sdPopoverInstance.hide();
        this.savedemandHandler();
      }
    })

    elem.find(".btn-savedemand").on("click", async (e) => {
        if (!(await this.validateForm())) {
          if (
            !this.context.user.isAdmin() ||
            !window.confirm("Error found in one of the fields. \"Cancel\" to abort save and check your inputs or \"Ok\" to proceed")
          ) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }
        }

        let changedData = await this.findChangedData();
        if (changedData.changes["Status"] && 
          closedStatus.includes(changedData.changes["Status"].new) && 
          !closedStatus.includes(changedData.changes["Status"].old)) {
            if (sdPopoverInstance.tip == null)
            sdPopoverInstance.show();
            return;
        };
        this.savedemandHandler();
    });
  }

  async savedemandHandler() {
    let changedData = await this.findChangedData();
    this.showLoading();

    //if (changedData.changes["status"])
    if (Object.keys(changedData).length > 0 && this.context.user.userId != this.data.responsible && location.hostname === "assignments.zoi.tech") {
      if (changedData.changes["Status"] && changedData.changes["Status"].new === DemandStatus.OpenSourcing) {
        await this.sendEmailsOnAssignmentDataChanged(changedData, true);
      } else {
        await this.sendEmailsOnAssignmentDataChanged(changedData, false);
      }
    }
    await this.updateHistory();
    await this.updateLocalData();

    if (changedData.changes["Responsible"]) {
      this.data.responsibleNotificationIssued = false;
    }
    if (changedData.changes["Resource"]) {
      this.data.assignedNotificationIssued = false;
    }

    await this.context.store.updateAssignment(this.data);
    this.context.store.getAssignmentsWithCalculatedEmployeesWeeklyHours();
    this.hideLoading();

    fireBaseLog("assignment_update", { assignmentId: this.data.id });

    showToast(`${this.data.projectId}: Assignment saved`, "success");
    if (this.resolve)
      this.resolve(this.data);
    setTimeout(async () => {
      await this.unsubscribeRealtimeAssignmentData();
      closeModal();
    });
  }

  updateDeleteBtnElementByUserRole() {
    const elem = $(this);

    if (
      !(
        this.context.user.isAdmin() ||
        (this.context.user.hasEditPermission() && this.data.responsible == this.context.user.userId)
      )
    ) {
      elem.find(".btn-delete").hide();
      return;
    }

    elem.find(".btn-delete").click(async (e) => {
      e.preventDefault();
      if (confirm("Are you sure you want to delete this?")) {
        this.showLoading();
        await this.context.store.deleteAssignment(this.data.id);
        this.context.store.deleteAssignmentHistory(this.data.id);
        this.hideLoading();

        showToast(`${this.data.projectId}: Assignment deleted`, "success");

        fireBaseLog("assignment_delete", { assignmentId: this.data.id });

        if (this.resolve) {
          this.resolve(null);
        }

        setTimeout(async () => {
          await this.unsubscribeRealtimeAssignmentData();
          closeModal();
        });
      }
    });
  }

  async findChangedData(saveOldValues = true): Promise<AssignmentsHistoryEntry> {
    let elem = $(this);
    let result: AssignmentsHistoryEntry = new AssignmentsHistoryEntry(this.context.user.userId, new Date(), {});

    const compareAndAssign = (field: string, oldValue: string | SkillSet | Language[], newValue: string | SkillSet | Language[]) => {
      const normalize = (value: string | SkillSet | Language[] | undefined | null) => {
        if (value == null || value == undefined) return "";
        if (typeof value === 'object') return JSON.stringify(value);
        return String(value);
      };
      if (!(normalize(oldValue) === normalize(newValue))) {
        result.changes[field] = { old: saveOldValues ? oldValue : "", new: newValue };
      }
    };


    for (const key in HistoryFields) {
      let newValue;
      if (key === 'description') {
        newValue = this.descriptionEditor ? this.descriptionEditor.getContents() : '';
      } else {
        newValue = elem.find(`#${key}`).val();
      }
      if (typeof newValue === "string") {
        compareAndAssign(HistoryFields[key as keyof typeof HistoryFields], this.data[key as keyof AssignmentDemand] as string, newValue);
      }
    }

    for (const key in HistoryDateFields) {
      let newValue = elem.find(`#${key}`).val();
      if (newValue && typeof newValue === "string") {
        let newDateValue = new Date(newValue);
        let oldDateValue = this.data[key as keyof AssignmentDemand] ? new Date(this.data[key as keyof AssignmentDemand] as string) : null;
        compareAndAssign(HistoryDateFields[key as keyof typeof HistoryDateFields], oldDateValue ? oldDateValue.toDateString() : '', newDateValue.toDateString());
      }
    }

    for (const key in HistoryBooleanFields) {
      let newValue = elem.find(`#${key}`).val();
      if (newValue && typeof newValue === "string") {
        compareAndAssign(HistoryBooleanFields[key as keyof typeof HistoryBooleanFields], String(this.data[key as keyof AssignmentDemand]).toUpperCase(), String(newValue).toUpperCase());
      }
    }


    compareAndAssign("Suggestions", this.data.suggestions.join(", "), this.suggestedEmployees.join(", "));
    compareAndAssign("Manually Planned", String(this.data.manuallyPlanned).toUpperCase(), String(this.manuallyPlanned).toUpperCase());

    let skills = new SkillSet();
    this.skillsTable.getData().forEach((skill: Skill) => {
      if (!skill.skill || !skill.category) return;
      skills.addSkill(new Skill(skill.category, skill.skill, skill.level));
    });

    compareAndAssign("Skills needed", this.data.skills, skills);
    let languages = this.languagesTable.getData();
    compareAndAssign("Languages", this.data.languages, languages);
    return result;
  }

  async sendEmailToMentionedEmployees(comment: string) {
    const mentionedEmails = this.getValidMentionedEmployeeIdsInComment(comment).map(
      (username) => username + "@zoi.tech"
    );

    if (mentionedEmails.length === 0) return;

    const currentUser = this.allEmployeesMap.get(this.context.user.userId);
    const currentUserNameStr = (currentUser ? currentUser.employeeName : "") + `(${this.context.user.userId}@zoi.tech)`;

    const recipients = [...mentionedEmails];

    await this.context.store.sendMentionedCommentEmail(recipients, comment, currentUserNameStr, window.location.href);
  }

  async sendEmailToResponsibleEmployeeOnNewComment(comment: string) {
    const currentUser = this.allEmployeesMap.get(this.context.user.userId);
    const currentUserNameStr = (currentUser ? currentUser.employeeName : "") + `(${this.context.user.userId}@zoi.tech)`;

    if (!currentUser || currentUser.id == this.data.responsible) return;

    const responsibleEmail = this.data.responsible + "@zoi.tech";
    await this.context.store.sendNewCommentEmail(responsibleEmail, comment, currentUserNameStr, window.location.href);
  }

  async sendEmailsOnAssignmentDataChanged(changedData: AssignmentsHistoryEntry, isStatusChanged: boolean) {
    let elem = $(this);
    const currentUser = this.allEmployeesMap.get(this.context.user.userId);
    const currentUserNameStr = (currentUser ? currentUser.employeeName : "") + `(${this.context.user.userId}@zoi.tech)`;
    const responsibleEmail = elem.find("#responsible").val() + "@zoi.tech";
    this.context.store.sendDataChangeEmail(
      this.data.id,
      responsibleEmail,
      currentUserNameStr,
      JSON.stringify(changedData),
      this.data.isNew ? true : false
    );
    if (isStatusChanged) {
      this.context.store.sendDataChangeEmail(
        this.data.id,
        "ml-recruiting@zoi.tech",
        currentUserNameStr,
        JSON.stringify(changedData),
        this.data.isNew ? true : false
      );
    }
  }

  /**
   * @param {string | null} comment
   * @returns {string[]}
   */
  getValidMentionedEmployeeIdsInComment(comment: string) {
    if (!comment) return [];

    // Match word begin with @ or +
    const mentionRegex = /(\@|\+)([\w\.\-]+)/gi;
    const matches = comment.match(mentionRegex);
    if (!matches) return [];

    const usernames = matches.map((matchWord) => {
      let result = this.removeTrailingDot(matchWord.substring(1));
      return result;
    });

    const toSendEmailsUsernames = _.uniq(
      usernames.filter((u) => this.allEmployeesMap.has(u) && u != this.context.user.userId)
    );

    return toSendEmailsUsernames;
  }

  /**
   * @param {string} str
   * @returns {string}
   */
  removeTrailingDot(str: string): string {
    if (!str.endsWith(".")) return str;

    const newStr = str.substring(0, str.length - 1);
    return this.removeTrailingDot(newStr);
  }

  /**
   * @returns {string}
   */
  buildStatusSelectOptionsHtml() {
    return this.status
      .map((status) => {
        return `<option value="${status}" ${status === this.data.status ? "selected" : ""}>${status}</option> `;
      })
      .join("");
  }

  getDirtyFieldValue(value: string) {
    return this.dirtyFields[value] ? this.dirtyFields[value] : null;
  }

  /**
   * @returns {string}
   */
  buildSenioritySelectOptionsHtml() {
    return this.seniorities
      .map(
        (seniority) =>
          `<option value="${seniority}" ${seniority === this.data.seniority ? "selected" : ""}>${seniority}</option> `
      )
      .join("");
  }

  /**
   * @returns {string}
   */
  buildCustomerSelectOptionsHtml() {
    // Check if the current customer exists in the customers list
    const customerExists = this.customers.includes(this.data.customer);
    return (
      this.customers
        .map((customer) => {
          return `<option value="${customer}" ${customer === this.data.customer ? "selected" : ""
            }>${customer}</option> `;
        })
        // Add the current customer if not in the list
        .concat(customerExists || this.data.customer == "" ? [] : [`<option value="${this.data.customer}" selected>${this.data.customer}</option>`])
        .join("")
    );
  }

  /**
   * @returns {string}
   */
  buildCommentItemsHtml() {
    return this.assignmentComments ? this.assignmentComments
      .map((comment) => {
        const titleText = `${comment.createdBy}  ${comment.createdDate.toLocaleString()}`;

        return `
                    <div class="d-flex flex-column mb-2">
                        <div class="d-flex justify-content-between align-items-center flex-wrap">
                            <strong class="text-break" title="${titleText}">${comment.createdBy}:</strong>
                            <p class="fs-7 fw-light m-0">${comment.createdDate.toLocaleString()}</p>
                        </div>

                        <p class="white-space-pre-wrap m-0">${comment.message}</p>
                    </div>
                `;
      })
      .join("") : '';
  }
}
